<div class="row w-100 mx-0 px-0">
  <div class="col-md-12 col-xl-12  d-flex justify-content-center">
    <div class="card p-2 m-2 p-md-5 m-md-5 col-8">
      <div class="">
        <div class="row pb-4">
          {{ 'SUBMIT.TITLE_1' | translate }} 
        </div>
        <div class="row">
          <div class="col-12">
            <div class="auth-form-wrapper">
              <form class="forms-sample" [formGroup]="submitForm" [markRequired]="submitForm">

                <div class="col-12 title mb-2">
                  {{ 'SUBMIT.CONTACT' | translate }} 
                </div>
                <div class="col-12 pb-4">
                  {{ 'SUBMIT.CONTACT_NAME_NOTE' | translate }} 
                </div>
                <div class="row separator"></div>

                <div class="row">
                  <div class="form-group col-sm-12 col-md-6">
                    <label for="inputContactName">{{ 'SUBMIT.CONTACT_NAME' | translate }}</label> <br/>
                    <extended-input [inputControl]="submitForm.get('contact_name')">
                      <input type="text"
                          class="form-control"
                          id="inputContactName"
                          formControlName="contact_name"
                          (change)="onFormChange()"
                          placeholder="{{ 'AUTH.PLACEHOLDER_PRE' | translate }} {{ 'SUBMIT.CONTACT_NAME' | translate }}">
                    </extended-input>
                  </div>

                  <div class="form-group col-sm-12 col-md-6">
                    <label for="inputContactTitle">{{ 'SUBMIT.CONTACT_TITLE' | translate }}</label>
                    <extended-input [inputControl]="submitForm.get('contact_title')">
                      <input type="text"
                          class="form-control"
                          id="inputContactTitle"
                          formControlName="contact_title"
                          (change)="onFormChange()"
                          placeholder="{{ 'AUTH.PLACEHOLDER_PRE' | translate }} {{ 'SUBMIT.CONTACT_TITLE' | translate }}">
                    </extended-input>
                  </div>
                </div>
                <div class="row">
                  <div class="form-group col-sm-12 col-md-6">
                    <label for="inputContactMail">{{ 'SUBMIT.CONTACT_MAIL' | translate }}</label>
                    <extended-input [inputControl]="submitForm.get('contact_email')">
                      <input type="text"
                          class="form-control"
                          id="inputContactMail"
                          formControlName="contact_email"
                          (change)="onFormChange()"
                          placeholder="{{ 'AUTH.PLACEHOLDER_PRE' | translate }} {{ 'SUBMIT.CONTACT_MAIL' | translate }}">
                    </extended-input>
                  </div>
                  <div class="form-group col-sm-12 col-md-6">
                    <label for="inputContactMail">{{ 'SUBMIT.CONTACT_PHONE' | translate }}</label> <small class="m-2">{{ 'SUBMIT.CONTACT_PHONE_NOTE' | translate }}</small>
                    <extended-input [inputControl]="submitForm.get('contact_phone')">
                    <input type="text"
                          class="form-control"
                          id="inputContactPhone"
                          formControlName="contact_phone"
                          (change)="onFormChange()"
                          placeholder="{{ 'AUTH.PLACEHOLDER_PRE' | translate }} {{ 'SUBMIT.CONTACT_PHONE' | translate }}">
                    </extended-input>
                  </div>
                </div>

                <div class="col-12 title">
                  {{ 'SUBMIT.GENERAL' | translate }} 
                </div>
                <div class="col-12 separator"></div>

                <div class="row">
                  <div class="form-group col-sm-12 col-md-6">
                    <label for="inputSchoolName">{{ 'SUBMIT.SCHOOL_NAME_ADULTS' | translate }}</label>
                    <extended-input [inputControl]="submitForm.get('institute_name')">
                      <input type="text"
                          class="form-control"
                          id="inputSchoolName"
                          formControlName="institute_name"
                          (change)="onFormChange()"
                          placeholder="{{ 'AUTH.PLACEHOLDER_PRE' | translate }} {{ 'SUBMIT.SCHOOL_NAME_ADULTS' | translate }}">
                    
                    </extended-input>
                  </div>

                  <div class="form-group col-sm-12 col-md-6">
                    <label for="inputLanguage">{{ 'SUBMIT.LANGUAGE' | translate }}</label>
                    <extended-input [inputControl]="submitForm.get('language')">
                      <ng-select [items]="languageItems"
                              bindLabel="{{ langBindLabel }}"
                              bindValue="id"
                              [searchable]="false"
                              [clearable]="false"
                              (change)="onFormChange()"
                              formControlName="language">
                        <ng-template ng-label-tmp let-item="item" let-clear="clear">
                          <span *ngIf="submitForm.get('language').value !== 'OTHER'" class="ng-value-label">{{item[langBindLabel]}}</span>
                          <span *ngIf="submitForm.get('language').value === 'OTHER'" class="ng-value-label">
                            {{item[langBindLabel]}}
                            <small class="text-small px-2">{{ 'SUBMIT.ADD_IN_NOTES' | translate }}</small>
                          </span>
                        </ng-template>
                        <ng-template ng-option-tmp let-item="item">
                          {{item[langBindLabel]}}
                        </ng-template>
                      </ng-select>
                    </extended-input>
                  </div>
                </div>

                <div class="row">
                  
                  <div class="form-group col-sm-12 col-md-6">
                    <label for="inputType">{{ 'SUBMIT.TYPE' | translate }}</label>
                    <extended-input [inputControl]="submitForm.get('online_type')">
                      <ng-select [items]="typeItems"
                              bindLabel="{{ typeBindLabel }}"
                              bindValue="id"
                              [searchable]="false"
                              [clearable]="false"
                              (change)="onFormChange()"
                              formControlName="online_type">
                      </ng-select>
                    </extended-input>
                  </div>     
                
                  <div class="form-group col-sm-12 col-md-6">
                    <label for="adultInstituteType">{{ 'SUBMIT.ADULT_INST_TYPE' | translate }}</label>
                    <extended-input [inputControl]="submitForm.get('adultInstituteType')">
                      <ng-select [items]="adultInstituteTypeItems"
                              bindLabel="{{ adultInstituteTypeLabel }}"
                              bindValue="id"
                              [clearable]="false"
                              [searchable]="false"
                              (change)="onFormChange()"
                              formControlName="adultInstituteType">
                      </ng-select>
                    </extended-input>
                  </div>
                </div>

                <div class="row">
                  <div class="form-group col">
                    <label for="inputWeekdays">{{ 'SUBMIT.WEEKDAYS' | translate }}</label>
                    <extended-input [inputControl]="submitForm.get('weekdays')">
                      <ng-select [items]="weekdaysItems" #weekdaysSelect
                              bindLabel="{{ weekdaysBindLabel }}"
                              bindValue="id"
                              [multiple]=true
                              [closeOnSelect]="false"
                              [searchable]="false"
                              groupBy="all"
                              [selectableGroup]="true"
                              (change)="onFormChange()"
                              formControlName="weekdays">

                            <ng-template ng-optgroup-tmp let-item="item" let-item$="item$" let-index="index">
                              <input id="item-{{index}}" type="checkbox" [checked]="item$.selected"/> <span class="m-3">{{'ALL' | translate}}</span>
                            </ng-template>
                            <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                                <input id="item-{{index}}" type="checkbox" [checked]="item$.selected"/> <span class="m-3">{{item[weekdaysBindLabel]}}</span>
                            </ng-template>
                            <ng-template ng-label-tmp let-item="item" >
                              <div class="ng-value">
                                <span *ngIf="item">{{item[weekdaysBindLabel]}}</span>
                                <span *ngIf="!item[weekdaysBindLabel]">{{ 'ALL' | translate}}</span>
                              </div>
                            </ng-template>
                      </ng-select>
                    </extended-input>
                  </div>
                </div>

                <div class="col-12 title">
                  {{ 'SUBMIT.LOCATION' | translate }} 
                </div>
                <div class="row separator"></div>

                <div class="row">
                  
                  <div class="form-group col">
                    <label for="inputCities">{{ 'SUBMIT.CITY' | translate }}</label>
                    <extended-input *ngIf="isIsrael(); else freeTxt" [inputControl]="submitForm.get('city')">
                      <ng-select [items]="cityItems"
                              bindLabel="{{ cityBindLabel }}"
                              bindValue="id"
                              [closeOnSelect]="true"
                              [searchable]="true"
                              (change)="onFormChange()"
                              formControlName="city">
                      </ng-select>
                    </extended-input>
                    <ng-template #freeTxt>
                      <extended-input [inputControl]="submitForm.get('city')">
                        <input type="text"
                            class="form-control"
                            id="cityInput"
                            formControlName="city"
                            (change)="onFormChange()"
                            placeholder="{{ 'AUTH.PLACEHOLDER_PRE' | translate }} {{ 'SUBMIT.CITY' | translate }}">
                      </extended-input>
                    </ng-template>
                  </div>
                </div>

                <div class="form-group">
                  <label for="inputCountry">{{ 'SUBMIT.COUNTRY' | translate }}</label>
                  <ng-select [items]="countryItems"
                          bindLabel="{{ countryBindLabel }}"
                          bindValue="id"
                          [closeOnSelect]="true"
                          [searchable]="true"
                          (change)="onCountryChange(); onFormChange()"
                          formControlName="country">
                  </ng-select>
                </div>
                
                <div class="row">
                  <div class="form-group col-sm-12 col-md-6">
                    <label for="inputStreet">{{ 'SUBMIT.STREET' | translate }}</label>
                    <extended-input [inputControl]="submitForm.get('street')">
                      <input type="text"
                          class="form-control"
                          id="inputStreet"
                          formControlName="street"
                          (change)="onFormChange()"
                          placeholder="{{ 'AUTH.PLACEHOLDER_PRE' | translate }} {{ 'SUBMIT.STREET' | translate }}">
                    </extended-input>
                  </div>
                  <div class="form-group col-sm-12 col-md-6">
                    <label for="inputHouseNum">{{ 'SUBMIT.HOUSE_NUMBER' | translate }}</label>
                    <extended-input [inputControl]="submitForm.get('house_number')">
                      <input type="text"
                            class="form-control"
                            id="inputHouseNum"
                            formControlName="house_number"
                            (change)="onFormChange()"
                            placeholder="{{ 'AUTH.PLACEHOLDER_PRE' | translate }} {{ 'SUBMIT.HOUSE_NUMBER' | translate }}">
                    </extended-input>
                  </div>
                </div>

                <div class="col-12 title">
                  {{ 'SUBMIT.NOTES' | translate }} 
                </div>
                <div class="row separator"></div>
                
                <div class="form-group">
                  <label for="inputNotes">{{ 'SUBMIT.NOTES' | translate }}</label>
                  <textarea
                        class="form-control"
                        id="inputNotes"
                        formControlName="notes"
                        (change)="onFormChange()"
                        placeholder="{{ 'AUTH.PLACEHOLDER_PRE' | translate }} {{ 'SUBMIT.NOTES' | translate }}">
                  </textarea>
                </div>

                <!-- <re-captcha [(ngModel)]="declarativeFormCaptchaValue" name="captcha" required></re-captcha> -->
                        
                <div class="my-5">
                  <div class="col-12 center">
                    <button type="submit" (click)="submit()"
                      class="btn btn-primary submit-btn col-sm-12 col-md-8">
                      
                      <span *ngIf="!success && !fail" class="d-flex align-middle justify-content-center">
                        <ng-lottie *ngIf="loading" style="width: 30px; height: 30px"
                          [options]="loadOptions" >
                        </ng-lottie>
                        <span *ngIf="!loading" style="width: 30px; height: 30px"></span>
                        <span class="px-2" style="line-height: 160%;">
                          {{ 'SUBMIT.SUBMIT' | translate }}
                        </span>
                        <span style="width: 30px; height: 30px"></span>
                      </span>

                      <span *ngIf="success" class="d-flex align-middle justify-content-center">
                        <ng-lottie style="width: 30px; height: 30px"
                          [options]="checkOptions" >
                        </ng-lottie>
                        <span class="px-2" style="line-height: 160%;">
                          {{ 'SUBMIT.SENT_OK' | translate }}
                        </span>
                        <span style="width: 30px; height: 30px"></span>
                      </span>

                      <span *ngIf="fail" class="d-flex align-middle justify-content-center">
                        <ng-lottie style="width: 30px; height: 30px"
                          [options]="xOptions" >
                        </ng-lottie>
                        <span class="px-2" style="line-height: 160%;">
                          {{ 'SUBMIT.SENT_FAIL' | translate }}
                        </span>
                        <span style="width: 30px; height: 30px"></span>
                      </span>
                      
                    </button>
                  </div>
                  <div *ngIf="success" class="col-12 title center" style="min-height: 280px;">
                    <span class="px-2" style="line-height: 160%;">
                      {{ 'SUBMIT.THANKYOU' | translate }}
                    </span>
                  </div>
                  <div *ngIf="!success && !fail && !invalid" class="col-12 title center placeholder" style="min-height: 280px;">
                    <span class="px-2" style="line-height: 160%;">
                      
                    </span>
                  </div>

                  <div *ngIf="fail" class="col-12 title center" style="min-height: 280px;">
                    <span class="px-2 failure" style="line-height: 160%;">
                      {{ 'SUBMIT.FAILURE' | translate }}
                    </span>
                  </div>

                  <div *ngIf="invalid" class="col-12 center" style="min-height: 280px;">
                    <span class="px-2 failure" style="line-height: 160%;">
                      {{ 'SUBMIT.INVALID' | translate }}
                    </span>
                  </div>
                </div>

                
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
